import React, { useState, useEffect } from 'react';
import './Header.css';
import Logo from './Logo';

function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <nav className="nav">
          <div className="logo">
            <Logo height={50} variant="dark" />
          </div>
          <ul className="nav-menu">
            <li><a onClick={() => scrollToSection('home')}>Inicio</a></li>
            <li><a onClick={() => scrollToSection('features')}>Características</a></li>
            <li><a onClick={() => scrollToSection('pricing')}>Precios</a></li>
            <li><a onClick={() => scrollToSection('testimonials')}>Testimonios</a></li>
            <li><a onClick={() => scrollToSection('contact')}>Contacto</a></li>
          </ul>
          <button className="btn btn-primary" onClick={() => scrollToSection('contact')}>
            Agendar Demo
          </button>
        </nav>
      </div>
    </header>
  );
}

export default Header;
